import React, { useState, useEffect } from 'react';

const AdminDashboard = () => {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  
  // Stati per filtri e ricerca
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all'); // 'all', 'bambini', 'allergie'

  const [activeTab, setActiveTab] = useState('guests');
  const [photos, setPhotos] = useState([]);

  const ADMIN_PASS = "sposi2026"; 

  const fetchGuests = async () => {
    try {
      const response = await fetch('/api/guests');
      const data = await response.json();
      setGuests(data);
      setLoading(false);
    } catch (error) {
      console.error("Errore fetch:", error);
      setLoading(false);
    }
  };

  const fetchPhotos = async () => {
    try {
      const response = await fetch('/api/photos');
      const data = await response.json();
      setPhotos(data);
    } catch (error) {
      console.error("Errore fetch foto:", error);
    }
  };

  const handleDeletePhoto = async (id) => {
    if(!window.confirm("Sei sicuro di voler eliminare questa foto?")) return;
    try {
      const res = await fetch(`/api/photos/${id}`, { method: 'DELETE' });
      if (res.ok) {
        setPhotos(photos.filter(p => p.id !== id));
      } else {
        alert("Errore durante l'eliminazione");
      }
    } catch (error) {
      console.error("Errore delete:", error);
      alert("Errore di connessione");
    }
  };

  const handleDeleteGuest = async (id) => {
    if(!window.confirm("Sei sicuro di voler eliminare questo ospite?")) return;
    try {
      const res = await fetch(`/api/guests/${id}`, { method: 'DELETE' });
      if (res.ok) {
        setGuests(guests.filter(g => g.id !== id));
      } else {
        alert("Errore durante l'eliminazione");
      }
    } catch (error) {
      console.error("Errore delete ospite:", error);
      alert("Errore di connessione");
    }
  };

  useEffect(() => {
    // Check Sessione
    const savedSession = localStorage.getItem('wedding_admin_session');
    if (savedSession === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      fetchGuests();
      fetchPhotos();
    }
  }, [isAuthenticated]);

  const handleLogin = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASS) {
      setIsAuthenticated(true);
      localStorage.setItem('wedding_admin_session', 'true');
    } else {
      alert("Password errata");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('wedding_admin_session');
    setIsAuthenticated(false);
    setPassword('');
  };

  // Logica di Filtraggio
  const filteredGuests = guests.filter(guest => {
    // 1. Filtro Ricerca (Nome o Cognome)
    const fullName = `${guest.nome} ${guest.cognome}`.toLowerCase();
    const matchesSearch = fullName.includes(searchTerm.toLowerCase());

    // 2. Filtro Categoria
    let matchesType = true;
    if (filterType === 'bambini') {
      matchesType = guest.is_bambino === 1;
    } else if (filterType === 'allergie') {
      matchesType = guest.allergie && guest.allergie !== 'Nessuna' && guest.allergie !== '';
    }

    return matchesSearch && matchesType;
  });

  // Calcolo Statistiche (Sempre sul totale, non sui filtrati)
  const totalGuests = guests.length;
  const totalChildren = guests.filter(g => g.is_bambino === 1).length;
  const totalAllergies = guests.filter(g => g.allergie && g.allergie !== 'Nessuna').length;
  const totalPhotos = photos.length;

  if (!isAuthenticated) {
    return (
      <div style={{
        height: '100vh', display: 'flex', flexDirection: 'column', 
        alignItems: 'center', justifyContent: 'center', background: '#fdfcfb',
        fontFamily: "'Josefin Sans', sans-serif", padding: '20px'
      }}>
        <h2 style={{textAlign: 'center', color: '#3a4a5c'}}>Area Riservata Sposi</h2>
        <form onSubmit={handleLogin} style={{display: 'flex', flexDirection: 'column', gap: '15px', width: '100%', maxWidth: '300px', marginTop: '20px'}}>
          <input 
            type="password" 
            placeholder="Password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{padding: '15px', border: '1px solid #c3e5ea', borderRadius: '8px', fontSize: '16px'}}
          />
          <button type="submit" style={{
            padding: '15px', background: '#8ac4d0', color: 'white', border: 'none', 
            cursor: 'pointer', borderRadius: '8px', fontSize: '16px', fontWeight: 'bold'
          }}>ACCEDI</button>
        </form>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', padding: '20px', background: '#f8f9fa',
      fontFamily: "'Josefin Sans', sans-serif"
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
            <h1 style={{ fontFamily: "'Cormorant Garamond', serif", color: '#3a4a5c', margin: 0, fontSize: '28px' }}>
            Dashboard
            </h1>
            <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <button onClick={handleLogout} style={{
                    background: 'none', border: '1px solid #e57373', borderRadius: '4px',
                    color: '#e57373', cursor: 'pointer', fontSize: '14px',
                    padding: '5px 10px', textTransform: 'uppercase'
                }}>
                    Esci
                </button>
                <button onClick={() => { fetchGuests(); fetchPhotos(); }} style={{background: 'none', border: 'none', color: '#8ac4d0', fontSize: '24px', cursor: 'pointer'}}>
                    ↻
                </button>
            </div>
        </div>
        
        {/* Tab Switcher */}
        <div style={{display: 'flex', gap: '20px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px'}}>
            <h2 
                onClick={() => setActiveTab('guests')}
                style={{
                    margin: 0, cursor: 'pointer', fontSize: '18px',
                    color: activeTab === 'guests' ? '#3a4a5c' : '#aaa',
                    borderBottom: activeTab === 'guests' ? '2px solid #3a4a5c' : 'none',
                    paddingBottom: '5px'
                }}
            >
                Ospiti
            </h2>
            <h2 
                onClick={() => setActiveTab('photos')}
                style={{
                    margin: 0, cursor: 'pointer', fontSize: '18px',
                    color: activeTab === 'photos' ? '#3a4a5c' : '#aaa',
                    borderBottom: activeTab === 'photos' ? '2px solid #3a4a5c' : 'none',
                    paddingBottom: '5px'
                }}
            >
                Foto ({totalPhotos})
            </h2>
        </div>

        {activeTab === 'guests' && (
            <>
                {/* Stats Cards - Scrolling orizzontale su mobile */}
                <div style={{ 
                    display: 'flex', gap: '15px', marginBottom: '30px', 
                    overflowX: 'auto', paddingBottom: '10px', scrollbarWidth: 'none' 
                }}>
                <StatCard title="Totale" value={totalGuests} color="#8ac4d0" icon="👥" />
                <StatCard title="Bambini" value={totalChildren} color="#f6cdca" icon="🧸" />
                <StatCard title="Allergie" value={totalAllergies} color="#e6beae" icon="⚠️" />
                </div>

                {/* Controlli Filtri e Ricerca */}
                <div style={{ background: 'white', padding: '20px', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
                    <input 
                        type="text" 
                        placeholder="Cerca invitato..." 
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{
                            width: '100%', padding: '12px', marginBottom: '15px', 
                            border: '1px solid #e8ebe6', borderRadius: '8px', fontSize: '16px',
                            fontFamily: "'Josefin Sans', sans-serif"
                        }}
                    />
                    
                    <div style={{display: 'flex', gap: '10px', overflowX: 'auto'}}>
                        <FilterButton active={filterType === 'all'} onClick={() => setFilterType('all')} label="Tutti" />
                        <FilterButton active={filterType === 'bambini'} onClick={() => setFilterType('bambini')} label="Solo Bambini" />
                        <FilterButton active={filterType === 'allergie'} onClick={() => setFilterType('allergie')} label="Con Allergie" />
                    </div>
                </div>

                {/* Lista Ospiti - Card View */}
                {loading ? (
                    <p style={{textAlign: 'center', color: '#888'}}>Caricamento...</p>
                ) : (
                    <div style={{display: 'flex', flexDirection: 'column', gap: '15px'}}>
                        {filteredGuests.length === 0 ? (
                            <p style={{textAlign: 'center', color: '#888', marginTop: '20px'}}>Nessun invitato trovato.</p>
                        ) : (
                            filteredGuests.map((g) => (
                                <div key={g.id} style={{
                                    background: 'white', padding: '20px', borderRadius: '12px',
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.03)',
                                    borderLeft: g.allergie && g.allergie !== 'Nessuna' ? '5px solid #e6beae' : '5px solid #c3e5ea',
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center'
                                }}>
                                    <div>
                                        <h3 style={{margin: '0 0 5px 0', fontSize: '18px', color: '#3a4a5c'}}>
                                            {g.nome} <span style={{fontWeight: 'bold'}}>{g.cognome}</span>
                                        </h3>
                                        <div style={{display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center'}}>
                                            {g.is_bambino === 1 && (
                                                <span style={{
                                                    background: '#f6cdca', color: '#fff', padding: '2px 8px', 
                                                    borderRadius: '4px', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px'
                                                }}>Bambino</span>
                                            )}
                                            {g.allergie && g.allergie !== 'Nessuna' && (
                                                <span style={{fontSize: '13px', color: '#d32f2f', display: 'flex', alignItems: 'center', gap: '4px'}}>
                                                    ⚠️ {g.allergie}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div style={{textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px'}}>
                                        <span style={{fontSize: '11px', color: '#aaa'}}>
                                            {new Date(g.data_registrazione).toLocaleDateString()}
                                        </span>
                                        <button 
                                            onClick={() => handleDeleteGuest(g.id)}
                                            style={{
                                                background: 'none', border: '1px solid #e57373', borderRadius: '4px',
                                                color: '#e57373', cursor: 'pointer', fontSize: '12px',
                                                padding: '2px 8px', textTransform: 'uppercase'
                                            }}
                                        >
                                            Elimina
                                        </button>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                )}
            </>
        )}

        {activeTab === 'photos' && (
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '15px'}}>
                {photos.map(photo => (
                    <div key={photo.id} style={{position: 'relative', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>
                        <img 
                            src={`/uploads/${photo.filename}`} 
                            alt={photo.didascalia}
                            style={{width: '100%', height: '150px', objectFit: 'cover'}} 
                        />
                        <div style={{padding: '10px', background: 'white'}}>
                            <p style={{margin: 0, fontSize: '12px', fontWeight: 'bold'}}>{photo.autore}</p>
                            <p style={{margin: '5px 0', fontSize: '11px', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{photo.didascalia}</p>
                            <button 
                                onClick={() => handleDeletePhoto(photo.id)}
                                style={{
                                    width: '100%', padding: '5px', background: '#e57373', color: 'white', 
                                    border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px'
                                }}
                            >
                                ELIMINA
                            </button>
                        </div>
                    </div>
                ))}
                {photos.length === 0 && <p style={{gridColumn: '1 / -1', textAlign: 'center', color: '#888'}}>Nessuna foto caricata.</p>}
            </div>
        )}

      </div>
    </div>
  );
};

const StatCard = ({ title, value, color, icon }) => (
  <div style={{ 
    background: 'white', padding: '15px', borderRadius: '12px', 
    minWidth: '110px', flex: 1, borderTop: `4px solid ${color}`,
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
  }}>
    <div style={{fontSize: '24px', marginBottom: '5px'}}>{icon}</div>
    <p style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#3a4a5c' }}>{value}</p>
    <h3 style={{ margin: '5px 0 0 0', fontSize: '11px', color: '#888', textTransform: 'uppercase', letterSpacing: '1px' }}>{title}</h3>
  </div>
);

const FilterButton = ({ active, onClick, label }) => (
    <button 
        onClick={onClick}
        style={{
            padding: '8px 16px',
            borderRadius: '20px',
            border: active ? 'none' : '1px solid #e8ebe6',
            background: active ? '#3a4a5c' : 'white',
            color: active ? 'white' : '#5a6a7c',
            cursor: 'pointer',
            fontSize: '13px',
            whiteSpace: 'nowrap',
            transition: 'all 0.3s ease',
            fontFamily: "'Josefin Sans', sans-serif"
        }}
    >
        {label}
    </button>
);

export default AdminDashboard;